// div that will be printed.

import React from 'react';
import { useRef } from 'react';
import styles from '../css/checkOutScreen.module.css';
import { ReactBarcode } from 'react-jsbarcode';

function PrintContainer({
  ticketNumber,
  locator,
  carInfo,
  colorInfo,
  licenseInfo,
  sectionInfo,
  laneInfo,
  spotInfo,
  empCard,
  barcode,
}) {
  const contentRef = useRef();
  return (
    <div className={styles.checkOutContainer}>
      <div ref={contentRef}>
        <div className={styles.sectionHeader}>
          <h4>Check Out Details</h4>
        </div>
        <div className={styles.inputGroup}>
          <label className={styles.checkOutLabel}>Ticket Number:</label>
          <label className={styles.resultLabel}>{ticketNumber}</label>
        </div>
        <div className={styles.inputGroup}>
          <label className={styles.checkOutLabel}>Locator:</label>
          <label className={styles.resultLabel}>{locator}</label>
        </div>
        {/* <div className={styles.inputGroup}>
          <label className={styles.checkOutLabel}>Checked In:</label>
          <label className={styles.resultLabel}>{checkIn}</label>
        </div> */}
        {/* <div className={styles.inputGroup}>
          <label className={styles.checkOutLabel}>Stay Duration:</label>
          <label className={styles.resultLabel}>
            {checkIn &&
              calculateTimeDifference(checkIn, new Date(), stayHrsRef.current, stayMinRef.current).timeDiff}
          </label>
        </div> */}
        <div className={styles.inputGroup}>
          <label htmlFor="carMake" className={styles.checkOutLabel}>
            Car Make:
          </label>
          <label className={styles.resultLabel}>{carInfo}</label>
        </div>
        <div className={styles.inputGroup}>
          <label htmlFor="carColor" className={styles.checkOutLabel}>
            Car Color:
          </label>
          <label className={styles.resultLabel}>{colorInfo}</label>
        </div>
        <div className={styles.inputGroup}>
          <label htmlFor="sectionName" className={styles.checkOutLabel}>
            Section Name:
          </label>
          <label className={styles.resultLabel}>{sectionInfo}</label>
        </div>
        <div className={styles.inputGroup}>
          <label htmlFor="laneNumber" className={styles.checkOutLabel}>
            Lane Number:
          </label>
          <label className={styles.resultLabel}>{laneInfo}</label>
        </div>
        <div className={styles.inputGroup}>
          <label htmlFor="spotNumber" className={styles.checkOutLabel}>
            Spot Number:
          </label>
          <label className={styles.resultLabel}>{spotInfo}</label>
        </div>
        <div className={styles.inputGroup}>
          <label htmlFor="licensePlate" className={styles.checkOutLabel}>
            License Plate:
          </label>
          <label className={styles.resultLabel}>{licenseInfo}</label>
        </div>
        <div className={styles.inputGroup}>
          <label htmlFor="cardNumber" className={styles.checkOutLabel}>
            Card Number:
          </label>
          <label className={styles.resultLabel}>{empCard}</label>
        </div>
        <div className={styles.inputGroup}>
          <ReactBarcode
            value={barcode}
            options={{
              format: 'CODE39',
              displayValue: true,
              lineColor: '#000',
              width: 2,
              height: 100,
            }}
            renderer="svg"
          />
        </div>
      </div>
    </div>
  );
}

export default PrintContainer;
